// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2vh8n","noInteraction":"EventWrapper_noInteraction__1YVzk"};